import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="page page-center">
      <div className="container-tight py-4">
        <div className="empty">
          <div className="empty-header">404</div>
          <p className="empty-title">Oops… Você acessou uma página inexistente</p>
          <p className="empty-subtitle text-muted">
            Desculpe, mas a página que você está procurando não foi encontrada
          </p>
          <div className="empty-action">
            <Link to="/" className="btn btn-primary">
              <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M5 12l14 0"></path>
                <path d="M5 12l6 6"></path>
                <path d="M5 12l6 -6"></path>
              </svg>
              Voltar para o início
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 